module.exports = __webpack_public_path__ + "static/img/lb2.406348e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb2.png
// module id = qciN
// module chunks = 1